import {
  Firestore,
  connectFirestoreEmulator,
  initializeFirestore,
} from "firebase/firestore";
import { app } from "./app";

const useEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATOR === "true";

// Against the Firestore emulator the default WebChannel transport trips the
// SDK's "INTERNAL ASSERTION FAILED: Unexpected state" watch-stream bug
// (firebase-js-sdk #7642) — reliably, because React.StrictMode double-
// subscribes every onSnapshot listener in dev and route changes churn them.
// Forcing long-polling avoids the bad transport path. Production keeps the
// default (auto-detected) transport.
export const db: Firestore = initializeFirestore(
  app,
  useEmulator ? { experimentalForceLongPolling: true } : {},
);

if (useEmulator) {
  connectFirestoreEmulator(
    db,
    `${import.meta.env.VITE_FIREBASE_EMULATOR_HOST}`,
    parseInt(import.meta.env.VITE_FIREBASE_EMULATOR_FIRESTORE_PORT, 10),
  );
}
